/**
 * Centralized error handling utility for service errors
 * This allows consistent error handling across all services
 */

/**
 * Handle errors from Supabase or other service operations
 * @param error The error object to handle
 * @returns A rejected promise with the error
 */
export function handleError(error: any): never {
  // Log the error for debugging
  console.error('Service error:', error);
  
  // Format the error message
  const errorMessage = error?.message || 'An unknown error occurred';
  
  // You can add additional error handling logic here
  // For example, sending errors to a monitoring service
  
  // Reject with a formatted error
  throw new Error(errorMessage);
}
